import {
  Zap, Heart, MessageCircleMore, UserRoundPlus, Send, StickyNote, SquarePlay,
} from 'lucide-react';

// Badge color palettes based on trend
export const BADGE_COLORS = {
  fire: { dark: { bg: '#461901', border: '#E17100', color: '#FFD230', chevron: '#FFBA00' }, light: { bg: '#FFFBEB', border: '#FFD230', color: '#E17100', chevron: '#E17100' } },
  up: { dark: { bg: '#022C22', border: '#009966', color: '#5EE9B5', chevron: '#00D492' }, light: { bg: '#ECFDF5', border: '#5EE9B5', color: '#009966', chevron: '#009966' } },
  none: { dark: { bg: '#0F172B', border: '#314158', color: '#90A1B9', chevron: '#90A1B9' }, light: { bg: '#FFFFFF', border: '#E2E8F0', color: '#62748E', chevron: '#62748E' } },
};

// Overview card visual config
export const OVERVIEW_CARD_CONFIG = [
  {
    key: 'rules',
    icon: Zap,
    iconColor: { dark: '#51A2FF', light: '#2B7FFF' },
    gradientAccent: { dark: '#162456', light: '#EFF6FF' },
    borderColor: { dark: '#1E3A5F', light: '#DBEAFE' },
  },
  {
    key: 'likes',
    icon: Heart,
    iconColor: { dark: '#FF637E', light: '#FF2056' },
    gradientAccent: { dark: '#4D0218', light: '#FFF1F2' },
    borderColor: { dark: '#5C1A2A', light: '#FECDD3' },
  },
  {
    key: 'comments',
    icon: MessageCircleMore,
    iconColor: { dark: '#00D3F2', light: '#00B8DB' },
    gradientAccent: { dark: '#053345', light: '#ECFEFF' },
    borderColor: { dark: '#0E4D5E', light: '#CFFAFE' },
  },
  {
    key: 'followings',
    icon: UserRoundPlus,
    iconColor: { dark: '#00D492', light: '#00BC7D' },
    gradientAccent: { dark: '#022C22', light: '#ECFDF5' },
    borderColor: { dark: '#0D3D30', light: '#A7F3D0' },
  },
  {
    key: 'messages',
    icon: Send,
    iconColor: { dark: '#C27AFF', light: '#AD46FF' },
    gradientAccent: { dark: '#3C0366', light: '#FAF5FF' },
    borderColor: { dark: '#4C1D7A', light: '#E9D5FF' },
  },
  {
    key: 'posts',
    icon: StickyNote,
    iconColor: { dark: '#FFBA00', light: '#FD9A00' },
    gradientAccent: { dark: '#461901', light: '#FFFBEB' },
    borderColor: { dark: '#5C2E0E', light: '#FDE68A' },
  },
  {
    key: 'storyViewed',
    icon: SquarePlay,
    iconColor: { dark: '#FB64B6', light: '#F6339A' },
    gradientAccent: { dark: '#510424', light: '#FDF2F8' },
    borderColor: { dark: '#6B1A3D', light: '#FBCFE8' },
  },
];
